'use strict';

import home from './home.png';
import back from './back.png';
import logo from './dog.jpg';
import trophy from './trophy.png';

import man_1 from './man/1.png';
import man_2 from './man/2.png';
import man_3 from './man/3.png';
import man_4 from './man/4.png';
import man_5 from './man/5.png';
import man_6 from './man/6.png';
import man_7 from './man/7.png';
import man_8 from './man/8.png';
import man_9 from './man/9.png';
import man_10 from './man/10.png';
import man_11 from './man/11.png';
import man_12 from './man/12.png';
import man_13 from './man/13.png';
import man_14 from './man/14.png';
import man_15 from './man/15.png';
import man_16 from './man/16.png';

import woman_1 from './woman/1.png';
import woman_2 from './woman/2.png';
import woman_3 from './woman/3.png';
import woman_4 from './woman/4.png';
import woman_5 from './woman/5.png';
import woman_6 from './woman/6.png';
import woman_7 from './woman/7.png';
import woman_8 from './woman/8.png';
import woman_9 from './woman/9.png';
import woman_10 from './woman/10.png';
import woman_11 from './woman/11.png';
import woman_12 from './woman/12.png';
import woman_13 from './woman/13.png';
import woman_14 from './woman/14.png';
import woman_15 from './woman/15.png';
import woman_16 from './woman/16.png';

const manGroup = [
    { name: '남궁설' , group: '그 여름은 끝나지 않았다', src: man_1 },
    { name: '유진 에반스' , group: '내 집사는 비정규직', src: man_2 },
    { name: '읭읭이' , group: '레바툰', src: man_3 },
    { name: '해일' , group: '마법사의 아이', src: man_4 },
    { name: '베릴' , group: '못난오리', src: man_5 },
    { name: '강준서' , group: '블루윙', src: man_6 },
    { name: '강훤' , group: '삐뚤어질테다', src: man_7 },
    { name: '정우' , group: '소비러와 존잘남', src: man_8 },
    { name: '문태수' , group: '아가씨와 우렁총각', src: man_9 },
    { name: '오딘', group: '오딘', src: man_10 },
    { name: '한우진', group: '우리사이느은', src: man_11 },
    { name: '우민', group: '잠자는 공주와 꿈꾸는 악마', src: man_12 },
    { name: '김유진', group: '탐정 메모리즈', src: man_13 },
    { name: '대검', group: '한복이 너무해', src: man_14 },
    { name: '이겨울', group: '한여름이겨울', src: man_15 },
    { name: '고성태', group: '히어로 왈츠', src: man_16 },
];

const womanGroup = [
    { name: '백아현' , group: '그 여름은 끝나지 않았다', src: woman_1 },
    { name: '이다음' , group: '내 집사는 비정규직', src: woman_2 },
    { name: '그 누나' , group: '레바툰', src: woman_3 },
    { name: '트리샤' , group: '마법사의 아이', src: woman_4 },
    { name: '오리' , group: '못난오리', src: woman_5 },
    { name: '강유리' , group: '블루윙', src: woman_6 },
    { name: '백소미' , group: '삐뚤어질테다', src: woman_7 },
    { name: '주인' , group: '소비러와 존잘님', src: woman_8 },
    { name: '임수하' , group: '아가씨와 우렁총각', src: woman_9 },
    { name: '프라야', group: '오딘', src: woman_10 },
    { name: '도가영', group: '우리사이느은', src: woman_11 },
    { name: '악마', group: '잠자는 공주와 꿈꾸는 악마', src: woman_12 },
    { name: '한지선', group: '탐정 메모리즈', src: woman_13 },
    { name: '소촌', group: '한복이 너무해', src: woman_14 },
    { name: '한여름', group: '한여름이겨울', src: woman_15 },
    { name: '은가람', group: '히어로 왈츠', src: woman_16 },
];

const etc = [
    { src: logo },
    { src: back },
    { src: home },
    { src: trophy },
];

export { manGroup, womanGroup, etc };



//////////////////
// WEBPACK FOOTER
// ./js/components/assets/Characters.js
// module id = 45
// module chunks = 0